import common from "./common";

export default class DifficultySystem {
    constructor() {
        this._levelChange = 0;
    }

    setProgression(correct) {
        console.log(this.levelUnclamped);
        if (this.levelUnclamped > 0 && correct <= common.config.game.difficulty.min) {
            this._progressLevel(false);
            this._levelChange = -1;
            console.log("level went down:", this.levelUnclamped);
        } else if (this.levelUnclamped < 4 && correct >= common.config.game.difficulty.max) {
            this._progressLevel(true);
            this._levelChange = 1;
            console.log("level went up:", this.levelUnclamped)
        } else {
            this._levelChange = 0;
            console.log("level no change");
        }
    }

    _progressLevel(advance) {
        const location = common.location;
        if (location.id) {
            const level = Math.max(0, Math.min(4, advance ? this.levelUnclamped + 1 : this.levelUnclamped - 1));
            common.save.setUserDifficultyLevel(common.userId, location.id, level);
        } else {
            console.warn("Location not set.");
        }
    }

    getLevel(location) {
        return location.id ? P3.math.clamp(common.save.getUserDifficultyLevel(common.userId, location.id), 0, 3) : -1;
    }

    getLevelUnclamped(location) {
        return location.id ? common.save.getUserDifficultyLevel(common.userId, location.id) : -1;
    }

    get level() {
        return this.getLevel(common.location);
    }

    get levelUnclamped() {
        return this.getLevelUnclamped(common.location);
    }

    get levelChange() {
        return this._levelChange;
    }
}